// @ts-ignore
import { defineCustomElements } from '@ionic/core/dist/esm';
export function appInitialize(config) {
    return function () {
        var win = window;
        if (typeof win !== 'undefined') {
            var Ionic = win.Ionic = win.Ionic || {};
            Ionic.config = config;
            Ionic.ael = function (elm, eventName, cb, opts) {
                if (elm.__zone_symbol__addEventListener) {
                    elm.__zone_symbol__addEventListener(eventName, cb, opts);
                }
                else {
                    elm.addEventListener(eventName, cb, opts);
                }
            };
            Ionic.rel = function (elm, eventName, cb, opts) {
                if (elm.__zone_symbol__removeEventListener) {
                    elm.__zone_symbol__removeEventListener(eventName, cb, opts);
                }
                else {
                    elm.removeEventListener(eventName, cb, opts);
                }
            };
            Ionic.raf = function (cb) {
                if (win.__zone_symbol__requestAnimationFrame) {
                    win.__zone_symbol__requestAnimationFrame(cb);
                }
                else {
                    win.requestAnimationFrame(cb);
                }
            };
            // define all of Ionic's custom elements
            defineCustomElements(win);
        }
    };
}
